/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */


/**
 * NOTE: This is an auto-generated file changes within may be overwritten
 * Run `yarn workspace @looker/icons build` to update
 */

import React from 'react'
import type { StyledIcon, StyledIconProps } from '@styled-icons/styled-icon'
import { StyledIconBase } from '@styled-icons/styled-icon'

export const CalendarHour: StyledIcon = React.forwardRef<
  SVGSVGElement,
  StyledIconProps
>((props, ref) => {
  const attrs: React.SVGProps<SVGSVGElement> = {
      "fill": "currentColor",
  "xmlns": "http://www.w3.org/2000/svg",
  }

  return (
    <StyledIconBase
      iconAttrs={attrs}
      iconVerticalAlign="middle"
      iconViewBox="0 0 24 24"
      {...props}
      ref={ref}
    >
      <path d="M21 6V20C21 21.1 20.1 22 19 22H5C3.89 22 3 21.1 3 20L3.01 6C3.01 4.9 3.89 4 5 4H6V2H8V4H16V2H18V4H19C20.1 4 21 4.9 21 6ZM5 8H19V6H5V8ZM19 20V10H5V20H19Z" />

      <path d="M8.67422 18H7.46719V14.6953L7.47891 14.1523L7.49844 13.5586C7.29792 13.7591 7.15859 13.8906 7.08047 13.9531L6.42422 14.4805L5.84219 13.7539L7.68203 12.2891H8.67422V18ZM14.1961 18H13.0047V15.4492C13.0047 14.819 12.7703 14.5039 12.3016 14.5039C11.9682 14.5039 11.7273 14.6172 11.5789 14.8438C11.4305 15.0703 11.3562 15.4375 11.3562 15.9453V18H10.1648V11.9219H11.3562V13.1602C11.3562 13.2565 11.3471 13.4831 11.3289 13.8398L11.3016 14.1914H11.3641C11.6297 13.7643 12.0516 13.5508 12.6297 13.5508C13.1427 13.5508 13.532 13.6888 13.7977 13.9648C14.0633 14.2409 14.1961 14.6367 14.1961 15.1523V18ZM17.4602 13.5508C17.6216 13.5508 17.7557 13.5625 17.8625 13.5859L17.7727 14.7031C17.6763 14.6771 17.5591 14.6641 17.4211 14.6641C17.0409 14.6641 16.744 14.7617 16.5305 14.957C16.3195 15.1523 16.2141 15.4258 16.2141 15.7773V18H15.0227V13.6328H15.925L16.1008 14.3672H16.1594C16.2948 14.1224 16.4771 13.9258 16.7062 13.7773C16.938 13.6263 17.1893 13.5508 17.4602 13.5508Z" />

    </StyledIconBase>
  )
})

CalendarHour.displayName = 'CalendarHour'

export const CalendarHourDimensions = {height: 24, width: 24}
